import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useUpdateTicketPriority } from '../../../hooks/TICKET/useUpdateTicketPriority';

const UpdatePriority = ({ showUpdatePriority, setShowUpdatePriority, priority }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ nom: '', label: '' });

    const { mutateAsync: updatePriority } = useUpdateTicketPriority();

    useEffect(() => {
        if (priority) setFormData({ nom: priority.name || '', label: priority.label || '' });
    }, [priority]);

    const hasChanges = priority && (
        formData.nom !== (priority.name || '') ||
        formData.label !== (priority.label || '')
    );

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        if (!hasChanges) { setShowUpdatePriority(false); return; }

        const priorityData = {};
        if (formData.nom !== (priority.name || '')) priorityData.nom = formData.nom || undefined;
        if (formData.label !== (priority.label || '')) priorityData.label = formData.label || undefined;

        setIsSubmitting(true);
        try {
            await updatePriority({ priorityId: priority.id, priorityData });
            setShowUpdatePriority(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={showUpdatePriority} onHide={() => setShowUpdatePriority(false)} size='md'>
            <Form onSubmit={handleSubmitForm}>
                <Modal.Header closeButton>
                    <Modal.Title><h5 className='text-muted modal-title'>Modifier la priorité</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="idNom">
                        <Form.Label className='text-muted'>Nom</Form.Label>
                        <Form.Control type="text" placeholder="Nom de la priorité" value={formData.nom} onChange={(e) => setFormData({ ...formData, nom: e.target.value })} maxLength={255} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="idLabel">
                        <Form.Label className='text-muted'>Label</Form.Label>
                        <Form.Control type="text" placeholder="Label de la priorité" value={formData.label} onChange={(e) => setFormData({ ...formData, label: e.target.value })} maxLength={255} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={isSubmitting} onClick={() => setShowUpdatePriority(false)}>Annuler</Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting || !hasChanges}>
                        {isSubmitting ? 'Chargement...' : 'Modifier'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default UpdatePriority;